import React from 'react'
import Grid from '../../../ui/grid'
import { FormInput } from '@myxplor/forms'

const ProvidingBody = ({ readOnly, values, onChange, isDetermination }) => {
  return (
    <fieldset>
      <legend>
        4. Person or State/Territory Body Providing Evidence{' '}
        {!isDetermination ? '(Optional)' : ''}
      </legend>
      <Grid>
        <FormInput
          htmlInput={{readOnly: readOnly}}
          label='First Name'
          name='state_details.first_name'
          value={values.state_details.first_name}
          maxLength={40}
          type='text'
          autoFocus={false}
          onChange={onChange}
          loading={false}
        />
        <FormInput
          htmlInput={{readOnly: readOnly}}
          maxLength={40}
          label='Last Name'
          name='state_details.last_name'
          value={values.state_details.last_name}
          type='text'
          autoFocus={false}
          onChange={onChange}
          loading={false}
        />
      </Grid>
      <FormInput
        htmlInput={{readOnly: readOnly}}
        label='Additional Information (Optional)'
        name='state_details.additional_infor'
        maxLength={1000}
        value={values.state_details.additional_infor}
        type='text'
        autoFocus={false}
        onChange={onChange}
        loading={false}
      />
    </fieldset>
  )
}
export default ProvidingBody



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/providing-body.js